import HeaderAnchorLinkMenu from './header-anchor-link-menu';
import HeaderOnscroll from './header-onscroll';
import HeaderQuickLinkMenu from './header-quick-link-menu';
import HeaderTakeoverMenu from './header-takeover-menu';
import HeaderUpdateHeight from './header-update-height';

const HeaderNav = (
    selector = '.header-nav', 
    opts = {
        takeoverSelector: '#takeoverModal',
        hamburgerSelector: '.btn-hamburger', // Note: Selector (not class)
        buttonSelector: '.visual-menu .btn-takeover-submenu', // Note: Selector (not class)
        backButtonClass: 'btn-back',
        submenuClass: 'header-nav__submenu',
        activeClass: 'is-active',
        noTransitionClass: 'no-transition',
    },
) => {
    const header = document.querySelector(selector);
    if (!header) return;

    // Handle header height css variables/updates
    HeaderUpdateHeight(header);

    // Add 'scrolled' class
    HeaderOnscroll(header);

    // Quick links
    HeaderQuickLinkMenu(header);

    // Anchor Links
    HeaderAnchorLinkMenu(header);
    
    // Takeover menu
    HeaderTakeoverMenu(header, opts);
}

export default HeaderNav;